import ReactMarkdown from "react-markdown";
import styled from "styled-components";

export const Markdown = styled(ReactMarkdown)`
  p {
    margin-bottom: 0px;
  }
`;
